export enum AppTitles {
  APP_TITLE = 'Together With',
  LOGOUT_TEXT = 'Logout',
}
